import numeral from 'numeral';

export default {
  withDelim(value) {
    return numeral(value).format('0,0[.]00');
  },
};
